import React, { memo } from 'react'
import { Typography } from '@mui/material'

const Text = ({ label, fontWeight = 400, variant = 'h4', ...restProps }) => {
  return (
    <Typography fontWeight={fontWeight} variant={variant} {...restProps}>
      {label}
    </Typography>
  )
}

export default memo(Text)
